
import Vue from "vue";
import { mapState } from "vuex";

export default Vue.extend({
  name: "PageFooter",
  data() {
    return {
      translation: {
        msg1: this.$t("sorrypage eisai"),
        msg2: this.$t("sorrypage cogstate"),
        msg3: this.$t("sorrypage privacy policy"),
        msg4: this.$t("sorrypage eisai copyright"),
      },
    };
  },
  computed: {
    logoEisai() {
      return `${this.$baseURL}img/i18n/${this.languageCode}/logo-eisai.png`;
    },
    logoCogstate() {
      return `${this.$baseURL}img/i18n/${this.languageCode}/logo-cogstate.png`;
    },
    ...mapState(["languageCode"]),
  },
});
